/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var numberList = "";
  var count = 0;

  var addmore = function addmore() {
    count++;
    var autofocus = "";
    if (count == 1) autofocus = "autofocus";
    numberList += "\n        <ul>\n          <li class=\"item-content item-input item-input-outline\">\n            <div class=\"item-inner\">\n              <div class=\"item-input-wrap\">\n                <input type=\"number\" pattern=\"\\d*\" " + autofocus + " maxlength = \"6\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"- - - - - -\" name=\"" + count + "\" id=\"number" + count + "\" class=\"myNumber\"/>\n                <span class=\"input-clear-button\"></span>\n              </div>\n              <div class=\"item-input-wrap\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"number" + count + "\" class=\"myNumber\"/>\n                <span class=\"input-clear-button\"></span>\n              </div>\n            </div>\n          </li>\n        </ul>\n  \n      ";
    $update();
  };

  $on('pageInit', function () {
    for (var i = 0; i < 5; i++) {
      addmore();
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
          </a>
        </div>
        <div class="title">
          <img src="static/images/gd.png" width="30px" style="vertical-align:middle"/>
          <span style="margin-left:10px;">GD Lotto 6D</span>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="block">
        Please fill in the form below to submit your betting. Good Luck.
      </div>
    
      <div class=block>
 
  
  
        <div class="row">
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">21 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">22 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">23 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">24 Jul</span>
            </label>
          </div>
        </div>
  
        <br/>
        <div class="row">
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">25 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">26 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">27 Jul</span>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content">
              <input type="checkbox" name="demo-checkbox" value="Books"  />
              <i class="icon icon-checkbox"></i>
              <span style="margin-left: -7px;">28 Jul</span>
            </label>
          </div>
        </div>
      </div>
  
      <div class="block">
        <table class="block" width=100% style="background-color:var(--f7-theme-color);border-top-left-radius: 10px;border-top-right-radius: 10px;font-size: 16px;font-weight: 700;height: 30px;">
        <td width="50%">
          Number
        </td>
        <td width="50%">
          Amount
        </td>
      </table>
      </div>


      
      <div class="block list inline-labels no-hairlines-md" style="margin-top: -35px;" innerHTML=${numberList}>
  
      </div>

      <div class="block">
        <div style="margin-top:-35px;background-color:var(--f7-theme-color);border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;font-size: 16px;font-weight: 700;height: 10px;">
  
        </div>
      </div>
      
      <p class="segmented block">
        <button class="button"></button>
        <button class="button" @click=${addmore}>Add More</button>
        <button class="button button-fill button-active">Submit</button>
        <span class="segmented-highlight"></span>
      </p>
  
  
  
  
      
  
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = 'c69ee2fb9b';
export default framework7Component;